export default __webpack_public_path__ + "static/media/cny-check-in-cn.2dfd8cd8.gif";